/** @format — Slim escalate badge used in document lists */

import { cn } from "@/lib/utils";

export default function EscalateBadge({ className }: { className?: string }) {
  return (
    <span
      role="button"
      tabIndex={0}
      className={cn(
        "box-border inline-flex h-[20px] max-h-[20px] min-h-[20px] shrink-0 cursor-pointer items-center justify-center self-center rounded-lg border border-red-600 bg-red-50 px-2 text-[11px] font-medium leading-[12px] text-red-700",
        className,
      )}
    >
      Escalate
    </span>
  );
}
